import { useCallback, useEffect, useState } from 'react';

import { User } from '../types';

const USER_INFO_KEY = 'user_info';

const useUserSession = () => {
  const storageKey = `${USER_INFO_KEY}`;
  const [userInfo, setUserInfo] = useState<Partial<User> | null>(() => getItem(storageKey));

  useEffect(() => {
    const handleStorageChange = () => {
      setUserInfo(getItem(storageKey));
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [storageKey]);

  const login = useCallback((userInfo: Partial<User>) => {
    setItem(storageKey, userInfo);
    setUserInfo(userInfo);
  }, [storageKey]);

  const logout = useCallback(() => {
    removeItem(storageKey);
    setUserInfo(null);
  }, [storageKey]);

  const isLoggedIn = !!userInfo;

  return { isLoggedIn, userInfo, login, logout };
};

export default useUserSession;

const setItem = (key: string, value: Partial<User>) => {
    console.log('user session setItem', key, value)
  localStorage.setItem(key, JSON.stringify(value));
};

export const getItem = (key: string) => {
  const data = localStorage.getItem(key);
  return data ? JSON.parse(data) : null;
};

const removeItem = (key: string) => {
  localStorage.removeItem(key);
};
